import { render, staticRenderFns } from "./cardWithAside.vue?vue&type=template&id=65e0d4c8"
import script from "./cardWithAside.vue?vue&type=script&lang=js"
export * from "./cardWithAside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports